  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import IconButton                                          from '@material-ui/core/IconButton';
//import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
  import ListItemText                                        from '@material-ui/core/ListItemText';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
//import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
  //----------------
  // core components
  //----------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";

//import Paper                                               from '@material-ui/core/Paper';
  import Menu                                                from '@material-ui/core/Menu';
//import MenuList                                            from '@material-ui/core/MenuList';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
//import Typography                                          from '@material-ui/core/Typography';
  //--------------------
  // 3rd party libraries
  //--------------------
//import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CardsService }                                 from "../../_services";
//import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_CurrenciesService }                            from "../../_services";
  //------
  // Style
  //------
  import CardListStyle                                    from "./CardListStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import Card_List_Icon                                      from "assets/img/wu/Card_List_Icon.svg";
  import WU_ThreeVerticalDots                                from "assets/img/wu/WU_ThreeVerticalDots.svg";
  import WU_DeleteCard                                       from "assets/img/wu/WU_DeleteCard.svg";
  //----------
  // variables
  //----------
  const filename = "CardList ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

class CardList extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    var token2Delete = "";

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      open                                                 : false,
      anchorEl                                             : null,

      //popup deleteCard
      dialog_deleteCard_msg                                  : "",
      dialog_deleteCard_isOpen                               : false,

      parserObject_cards                                   : [],
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                         = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                        = this.dialog200_handleClose.bind(this);

    this.handleListItemClick_deleteCard                               = this.handleListItemClick_deleteCard.bind(this);

    this.onListItemClick_card                                         = this.onListItemClick_card.bind(this);
    this.get_cardType_FromObj                                         = this.get_cardType_FromObj.bind(this);
    this.get_cardNumMasked_FromObj                                    = this.get_cardNumMasked_FromObj.bind(this);
    this.get_expDatetime_FromObj                                      = this.get_expDatetime_FromObj.bind(this);

    this.menuItem_handleClick                                         = this.menuItem_handleClick.bind(this);
    this.menuItem_handleClose1                                        = this.menuItem_handleClose1.bind(this);
    this.menuItem_handleClose2                                        = this.menuItem_handleClose2.bind(this);

    //popup deleteCard
    this.dialog_deleteCard_handleOpen                                 = this.dialog_deleteCard_handleOpen.bind(this);
    this.dialog_deleteCard_btn_cancel                                 = this.dialog_deleteCard_btn_cancel.bind(this);
    this.dialog_deleteCard_btn_delete                                 = this.dialog_deleteCard_btn_delete.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT,BP)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    //if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    //localStorage.setItem("accessToken", "bad717b8-e102-408f-97b0-9f8aefed26d2");
    //let shouldForceRefreshAccessToken = wu_Utilities.shouldForceRefreshAccessToken();
    //if(api.print_logs){console.log('cookie='+Cookies.get('testCookie'));}

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_cardslistdetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}

    //-------------
    //getCurrencies---CACHED
    //-------------
    let retrieveWSData_getCurrencies = wu_CurrenciesService.wu_should_getCurrencies();
    if(api.print_logs){console.log("retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
    if(retrieveWSData_getCurrencies){
      wu_CurrenciesService
      .wu_getCurrencies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="CardList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
      });
    }
    else{
      try{
        let res = JSON.parse(localStorage.getItem("currencies"));
        let parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      }catch(err){
        console.log('err='+err);
      }
    }



    this.setState({ "parserObject_cards": [] });
    this.startSpinners(); /*if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));}*/
    setTimeout(function() { //Start the timer
      //------------------
      //wu_cards_cardslist
      //------------------
      wu_CardsService
      .wu_cards_cardslist({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="CardList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.setState({ "parserObject_cards": res.custCardTokenList });
        this.stopSpinners();this.dialog200_handleClose();
      })
      .catch(err => {
        this.stopSpinners();this.dialog200_handleClose();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <GridContainer justify="center">
              <GridItem xs={2} sm={2} md={1}>
                <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                  {/* ----------[goBack]------------ */}
                  {/* <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button> */}
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("CardsList_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
              </GridItem>
            </GridContainer>

            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}

            {localStorage.getItem("mobileOpen")==="true" ? (
              <div style={{marginBottom:20}}>
                <List component="nav" aria-label="main mailbox folders">
                  {this.state.parserObject_cards.map(e => (
                    <React.Fragment key={"fragmentId_"+e.token}>
                      <ListItem onClick={(e1) => this.onListItemClick_card(e)}>
                        <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:25, paddingRight:0}}>
                          <GridItem xs={2} sm={2} md={2}>
                            <div className={classes.Card_List_Icon_mobile}><img src={Card_List_Icon} alt="Card_List_Icon_mobile" /></div>
                          </GridItem>
                          <GridItem xs={7} sm={7} md={7}>
                            <GridContainer justify="center" style={{paddingTop:0, paddingLeft:5}}>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_cardType}>{this.get_cardType_FromObj(e)}</div></GridItem>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_other}>{this.get_cardNumMasked_FromObj(e)}&nbsp;&nbsp;&nbsp;&nbsp;{this.get_expDatetime_FromObj(e)}</div></GridItem>
                            </GridContainer>
                          </GridItem>
                          <GridItem xs={3} sm={3} md={3}>
                            <GridContainer justify="center" style={{paddingTop:10, paddingRight:0, paddingLeft:0}}>
                              <GridItem xs={12} sm={12} md={12}>
                                <Button
                                  id="demo-positioned-button"
                                  aria-controls={this.state.open ? 'demo-positioned-menu' : undefined}
                                  aria-haspopup="true"
                                  aria-expanded={this.state.open ? 'true' : undefined}
                                  onClick={this.menuItem_handleClick}
                                >
                                  <div className={classes.ThreeVerticalDots_Icon_mobile}><img src={WU_ThreeVerticalDots} alt=""/></div>
                                  <Menu
                                    id="demo-positioned-menu"
                                    aria-labelledby="demo-positioned-button"
                                    anchorEl={this.state.anchorEl}
                                    open={this.state.open}
                                    onClose={this.menuItem_handleClose1}
                                    anchorOrigin={{vertical: 'top',horizontal: 'left',}}
                                    transformOrigin={{vertical: 'top',horizontal: 'left',}}
                                  >
                                    <MenuItem id={e.token} value={e.token} onClick={(event) => this.menuItem_handleClose2()}>
                                      <div className={classes.WU_DeleteCard_Icon}><img src={WU_DeleteCard} alt=""/></div>
                                      <ListItemText style={{marginLeft:30, marginRight:30}}>{this.NSInforString("CardsList_delete")}</ListItemText>
                                    </MenuItem>
                                  </Menu>
                                </Button>
                              </GridItem>
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                    </React.Fragment>
                  ))}
                </List>
              </div>
            ) : (
              <div style={{marginBottom:20}}>
                <List component="nav" aria-label="main mailbox folders">
                  {this.state.parserObject_cards.map(e => (
                    <React.Fragment key={"fragmentId_"+e.token}>
                      <ListItem onClick={(e1) => this.onListItemClick_card(e)}>
                        <GridContainer justify="center" style={{ border: '1px solid #787878', borderRadius: "6px", height:"100px", paddingTop:15, paddingRight:0}}>
                          <GridItem xs={3} sm={3} md={3}>
                            <div className={classes.Card_List_Icon_desktop}><img src={Card_List_Icon} alt="Card_List_Icon" /></div>
                          </GridItem>
                          <GridItem xs={7} sm={7} md={7}>
                            <GridContainer justify="center" style={{paddingTop:10, paddingLeft:0}}>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_cardType}>{this.get_cardType_FromObj(e)}</div></GridItem>
                              <GridItem xs={12} sm={12} md={12}><div className={classes.listItem_other}>{this.get_cardNumMasked_FromObj(e)}&nbsp;&nbsp;&nbsp;&nbsp;{this.get_expDatetime_FromObj(e)}</div></GridItem>
                            </GridContainer>
                          </GridItem>
                          <GridItem xs={2} sm={2} md={2}>
                            <GridContainer justify="center" style={{paddingTop:10, paddingRight:0, paddingLeft:0}}>
                              <GridItem xs={12} sm={12} md={12}>
                                <Button
                                  id="demo-positioned-button"
                                  aria-controls={this.state.open ? 'demo-positioned-menu' : undefined}
                                  aria-haspopup="true"
                                  aria-expanded={this.state.open ? 'true' : undefined}
                                  onClick={this.menuItem_handleClick}
                                >
                                  <div className={classes.ThreeVerticalDots_Icon_desktop}><img src={WU_ThreeVerticalDots} alt=""/></div>
                                  <Menu
                                    id="demo-positioned-menu"
                                    aria-labelledby="demo-positioned-button"
                                    anchorEl={this.state.anchorEl}
                                    open={this.state.open}
                                    onClose={this.menuItem_handleClose1}
                                    anchorOrigin={{vertical: 'top',horizontal: 'left',}}
                                    transformOrigin={{vertical: 'top',horizontal: 'left',}}
                                  >
                                    <MenuItem id={e.token} value={e.token} onClick={(event) => this.menuItem_handleClose2()}>
                                      <div className={classes.WU_DeleteCard_Icon}><img src={WU_DeleteCard} alt=""/></div>
                                      <ListItemText style={{marginLeft:30, marginRight:30}}>{this.NSInforString("CardsList_delete")}</ListItemText>
                                    </MenuItem>
                                  </Menu>
                                </Button>
                              </GridItem>
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                    </React.Fragment>
                  ))}
                </List>
              </div>
            )}

            {this.state.viewPleaseWait_hidden === true && this.state.parserObject_cards.length === 0 ? (
              <div style={{marginTop:20}}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.Card_List_Icon_Big}><img src={Card_List_Icon} alt="Card_List_Icon" /></div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.History_nohistory_lbl2}>{this.NSInforString("CardsList_nocards_lbl1")}</div></GridItem>
                </GridContainer>
              </div>
            ) : (
              ""
            )}
            {this.state.viewPleaseWait_hidden === true && this.state.parserObject_cards.length === 0 ? (
              <div style={{marginTop:20}}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.History_nohistory_lbl2}>{this.NSInforString("CardsList_nocards_lbl2")}</div></GridItem>
                </GridContainer>
              </div>
            ) : (
              ""
            )}

            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("CardsList_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP deleteCard]------------ */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_deleteCard_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_deleteCard_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.NSInforString("CardsList_areYouSure_lbl1")}</div></GridItem>
              <GridItem xs={12} sm={12} md={12}></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_deleteCard} color="default" onClick={this.dialog_deleteCard_btn_cancel}>{this.NSInforString("CardsList_areYouSure_no")}</Button>
              <Button className={classes.popupOkButton_deleteCard} color="default" onClick={this.dialog_deleteCard_btn_delete}>{this.NSInforString("CardsList_areYouSure_yes")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  onListItemClick_card(obj){
    let methName = filename+"onListItemClick_card ";
    if(api.print_logs){console.log(methName+"token="+obj.token);}

    this.setState({"parserObject_selectedTokenizedCard_forDeletion":obj});
  }
  //----------------------------------------------------------------------------------------------------
  get_cardType_FromObj(obj){
    if(obj){
      return obj.cardType;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_cardNumMasked_FromObj(obj){
    if(obj){
      return obj.cardNumMasked;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_expDatetime_FromObj(obj){
    if(obj){
      return obj.expDatetime.replace('-', '/');
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_deleteCard(event_trans_id){
    let methName = filename+"handleListItemClick_deleteCard ";
    if(api.print_logs){console.log(methName+event_trans_id);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //open pupup deleteCard
    this.dialog_deleteCard_handleOpen(this.NSInforString("networkerror"),"NET");
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_fullName_FromObj(obj){
    if(obj){
      return obj.rcv_fname + " " + wu_Utilities.addStars(obj.rcv_lname);
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_amount_FromObj(obj){
    if(obj && obj.totalAmount){
      return this.comvert2ProperAmountFormat(obj.totalAmount.toFixed(2));
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_countryName_FromObj(obj){
    if(obj && obj.country){
      return wu_Utilities.findCountryNameFromCountryId(obj.country,localStorage.getItem("lang"));
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  menuItem_handleClick(event: React.MouseEvent<HTMLElement>){
    let methName = filename+"menuItem_handleClick ";
    if(api.print_logs){console.log(methName);}

    if(this.state.open === false){
      this.setState({ "open": true, "anchorEl":event.currentTarget });
    }
  }
  //----------------------------------------------------------------------------------------------------
  menuItem_handleClose1(){
    let methName = filename+"menuItem_handleClose1 ";
    if(api.print_logs){console.log(methName+"token="+this.state.parserObject_selectedTokenizedCard_forDeletion.token);}

    this.setState({ "open": false, "anchorEl":null });
  }
  //----------------------------------------------------------------------------------------------------
  menuItem_handleClose2(){
    let methName = filename+"menuItem_handleClose2 ";
    if(api.print_logs){console.log(methName+"token="+this.state.parserObject_selectedTokenizedCard_forDeletion.token);}

    this.setState({ "open": false, "anchorEl":null });
    this.token2Delete = this.state.parserObject_selectedTokenizedCard_forDeletion.token;
    this.handleListItemClick_deleteCard();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {

    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  // dialog_handleOpen(dialog_msg){
  //   this.setState({
  //     "dialog_isOpen" : true,
  //     "dialog_msg"    : dialog_msg
  //   });
  // }
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS/3);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups deleteCard---------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_deleteCard_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_deleteCard_isOpen" : true,
        "dialog_deleteCard_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_deleteCard_btn_cancel(){
    this.setState({ "dialog_deleteCard_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  dialog_deleteCard_btn_delete(){
    let methName = filename+"dialog_deleteCard_btn_delete ";
    if(api.print_logs){console.log(methName+"token="+this.token2Delete);}

    this.setState({ "dialog_deleteCard_isOpen": false });

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));}//this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------------
      //wu_cards_cards_delete
      //---------------------
      wu_CardsService
      .wu_cards_cards_delete({token:this.token2Delete})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="CardList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //------------------
        //wu_cards_cardslist
        //------------------
        wu_CardsService
        .wu_cards_cardslist({})
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="CardList"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.stopSpinners();this.dialog200_handleClose();
          this.setState({ "parserObject_cards": res.custCardTokenList });
        })
        .catch(err => {
          this.stopSpinners();this.dialog200_handleClose();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });

      })
      .catch(err => {
        this.stopSpinners();this.dialog200_handleClose();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IE11----------------------------------------------
  //----------------------------------------------------------------------------------------------------
  // IE11_not_loading_state_workaround(){
  //   let ua   = window.navigator.userAgent;
  //   let msie = ua.indexOf("MSIE ");
  //   if (msie > 0 || !!ua.match(/Trident.*rv\:11\./)){
  //     let stateObj = {};
  //     let hasAField = false;
  //     //if(this.state.textField1===""){ stateObj.textField1 = Cookies.get('rcv_fname'); hasAField = true; }
  //     //if(this.state.textField2===""){ stateObj.textField2 = Cookies.get('rcv_lname'); hasAField = true; }
  //     if(hasAField===true){this.setState(stateObj);}
  //   }
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IOS12---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  isWebAppIOS12x() {
    let methName = filename+"isWebAppIOS12x ";
    try{
      let ua = window.navigator.userAgent;
      if (/iP(hone|od|ad)/.test(ua)) {
        var v = (ua).match(/OS (\d+)_(\d+)_?(\d+)?/);
        //return parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10);
        console.log(methName+"iOS version="+parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10));
        if(parseInt(v[1], 10)===12){
          return true;
        }
      }
    }catch(err){
      console.log(methName+"err="+err);
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
}
CardList.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(CardListStyle)(CardList)
);
